var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.25 14H8.75V0H5.25V14ZM0 14H3.5V7H0V14ZM10.5 14V4.375H14V14H10.5Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }